import { createRouter, createWebHashHistory } from 'vue-router';

import Landing from '@/views/landing/Landing.vue';
import Activation from '@/views/activation/Activation.vue';
import KuzoRegistration from '@/views/activation/KuzoRegistration.vue';
import Manage from '@/views/manage/Manage.vue';
import Profile from '@/views/profile/Profile.vue';
import TopUp from '@/views/TopUp.vue';
import Login from '@/views/login/Login.vue';
import PasswordReset from '@/views/login/PasswordReset.vue';
import PasswordChange from '@/views/profile/PasswordChange.vue';
import ForgottenLogin from '@/views/login/ForgottenLogin.vue';
import EmailChange from '@/views/profile/EmailChange.vue';
import VersionInfo from '@/views/VersionInfo.vue';
import AutoTopupActivationMPayLandingSuccess from '@/views/autotopup/AutoTopupActivationMPayLandingSuccess.vue'
import AutoTopupActivationMPayLandingError from '@/views/autotopup/AutoTopupActivationMPayLandingError.vue'
import AutoTopupActivationMPayLandingCancel from '@/views/autotopup/AutoTopupActivationMPayLandingCancel.vue'
import DeactivateAutoTopupConfirm from "@/views/autotopup/DeactivateAutoTopupConfirm.vue";
import DeactivateAutoTopupSuccess from '@/views/autotopup/DeactivateAutoTopupSuccess.vue';
import TopupVoucherSuccess from '@/views/topupOnce/TopUpVoucherSuccess.vue';
import TopupMpaySuccess from '@/views/topupOnce/TopUpMpaySuccess.vue';
import TopupMpayError from '@/views/topupOnce/TopUpMpayError.vue';
import TopupMpayCancel from '@/views/topupOnce/TopUpMpayCancel.vue';
import SsoLogin from '@/views/login/SsoLogin.vue';
import Invoices from '@/views/profile/Invoices.vue';

const routes: any = [
  {
    path: '/',
    name: 'landing',
    component: Landing,
  },
  {
    path: '/activation',
    name: 'activation',
    component: Activation,
  },
  {
    path: '/kuzoRegistration',
    name: 'kuzoRegistration',
    component: KuzoRegistration,
  },
  {
    path: '/protected/manage',
    name: 'manage',
    component: Manage,
  },
  {
    path: '/protected/profile',
    name: 'profile',
    component: Profile,
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
  },
  {
    path: '/protected/topUp',
    name: 'topUp',
    component: TopUp,
  },
  {
    path: '/passwordReset',
    name: 'passwordReset',
    component: PasswordReset,
  },
  {
    path: '/protected/passwordChange',
    name: 'passwordChange',
    component: PasswordChange,
  },
  {
    path: '/forgottenLogin',
    name: 'forgottenLogin',
    component: ForgottenLogin,
  },
  {
    path: '/protected/emailChange',
    name: 'emailChange',
    component: EmailChange,
  },
  {
    path: '/versionInfo',
    name: 'versionInfo',
    component: VersionInfo
  },
  {
    path: '/atuSuccess',
    name: 'atuSuccess',
    component: AutoTopupActivationMPayLandingSuccess
  },
  {
    path: '/atuCancel',
    name: 'atuCancel',
    component: AutoTopupActivationMPayLandingCancel
  },
  {
    path: '/atuError',
    name: 'atuError',
    component: AutoTopupActivationMPayLandingError
  },
  {
    path: '/atuDeactivated',
    name: 'atuDeactivated',
    component: DeactivateAutoTopupSuccess
  },
  {
    path: '/protected/deactivateAutoTopupConfirm',
    name: 'deactivateAutoTopupConfirm',
    component: DeactivateAutoTopupConfirm
  },
  {
    path: '/protected/topupVoucherSuccess',
    name: 'topupVoucherSuccess',
    component: TopupVoucherSuccess
  },
  {
    path: '/topupSuccess',
    name: 'topupMpaySuccess',
    component: TopupMpaySuccess
  },
  {
    path: '/topupError',
    name: 'topupMpayError',
    component: TopupMpayError
  },
  {
    path: '/topupCancel',
    name: 'topupMpayCancel',
    component: TopupMpayCancel
  },
  {
    path: '/ssoLogin',
    name: 'ssoLogin',
    component: SsoLogin
  },
  {
    path: '/loginWithToken',
    name: 'loginWithToken',
    component: SsoLogin
  },
  {
    path: '/protected/invoices',
    name: 'invoices',
    component: Invoices
  }
];

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior () {
    return { left: 0, top: 0 };
  }
});

export default router;
